import React from 'react';

import { style } from 'glamor';

type Props = {
  children: React.Element,
};

export default function ListVertical({children}: Props) {
  return (
    <ul {...style({listStyleType: 'none'})}>
      {children.map(child => <li key={child.key}>{child}</li>)}
    </ul>
  );
}



// WEBPACK FOOTER //
// ../src/client/components/list/ListVertical.js